import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el acceso una vez que pago?',
  a: 'Apenas se acredita el pago, recibís el acceso inmediato por mail. Podés entrar desde tu celular, tablet o computadora y empezar el mismo día. No hay envíos físicos ni demoras.'
}, {
  q: '¿Es realmente un pago único o después hay cargos mensuales?',
  a: 'Es un solo pago. No hay membresías, renovaciones automáticas ni costos ocultos. Pagás una vez y el acceso es tuyo de forma permanente.'
}, {
  q: '¿Cuánto tiempo tengo acceso al contenido?',
  a: 'El acceso es permanente. Podés volver a consultar las recetas, menús y guías cada vez que lo necesites, sin límite de tiempo.'
}, {
  q: '¿De verdad puedo cocinar para 15 días en solo 2 horas?',
  a: 'Sí, porque el sistema está pensado para producir varias comidas en paralelo con un orden estratégico. No cocinás 30 platos distintos desde cero, optimizás tiempos y procesos.'
}, {
  q: '¿Y si no me gusta cocinar o no tengo experiencia?',
  a: 'No necesitás experiencia previa. Las recetas están explicadas de forma simple y el paso a paso evita errores comunes. Está diseñado para personas comunes que quieren resolver su rutina.'
}, {
  q: '¿En qué se diferencia de buscar recetas gratis en internet?',
  a: 'Acá no comprás recetas sueltas. Tenés un sistema completo: menús armados, lista automática de compras, orden de cocción, técnicas de congelado y planificación integrada.'
}, {
  q: '¿Qué pasa si lo compro y siento que no es para mí?',
  a: 'Tenés 30 días de garantía. Si al probarlo sentís que no se adapta a tu rutina, podés pedir la devolución y recuperar tu dinero. Sin vueltas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-5 md:py-7 px-4 bg-white" data-id="element-55">
      <div className="max-w-3xl mx-auto" data-id="element-56">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight" data-id="element-57">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-1.5 md:space-y-2" data-id="element-58">
          {faqs.map((faq, i) => <div key={i} className="bg-[#F7F5F0] border border-black/5 overflow-hidden rounded-xl shadow-sm" data-id="element-59">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-3 md:px-4 py-2.5 md:py-3 text-left flex items-center justify-between hover:bg-black/5 transition-colors" aria-expanded={openIndex === i} data-id="element-60">
                <span className="text-xs md:text-sm font-bold text-text-primary pr-4" data-id="element-61">
                  {faq.q}
                </span>
                <ChevronDown className={`text-primary shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={16} data-id="element-62" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-63">
                <div className="px-3 md:px-4 pb-2.5 md:pb-3 text-text-primary/80 leading-relaxed border-t border-black/5 pt-2 text-[11px] md:text-xs font-medium" data-id="element-64">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}